<template>
  <div class="card">
    <div class="card-content">
      <base-table
        :service="$options.codeService"
        fetch-func="all"
        :fetch-params="fetchParams"
        :columns="$options.columns"
        default-sort-direction="desc"
        selectable
        :selected="selected"
        checkable
        :checked="checked"
        :is-row-checkable="row => (selected ? row.id !== selected.id : true)"
        :custom-is-checked="(checked, current) => checked.id === current.id"
        sticky
        :height="height"
        :narrowed="false"
        infinite-scroll
        @click="onClick"
        @check="onCheck"
        ref="baseTable"
      />
    </div>
  </div>
</template>

<script>
import BaseTable from "@/components/partials/BaseTable";
import { CodeService } from "@/services/code.service";

export default {
  codeService: CodeService,
  columns: [
    {
      field: "code",
      label: "Code"
    },
    {
      field: "name",
      label: "Name"
    },
    {
      field: "group",
      label: "Group"
    },
    {
      field: "type",
      label: "Type"
    }
  ],
  props: {
    height: {
      type: Number,
      default: 500
    },
    params: {
      type: Object,
      default: () => {}
    },
    selected: {
      type: Object
    },
    checked: {
      type: Array
    }
  },
  components: {
    BaseTable
  },
  computed: {
    fetchParams() {
      return {
        ...this.params,
        firm_firm_id: this.params.firm_firm_id,
        active: 1,
        includes: "firms,childCodes"
      };
    }
  },
  mounted() {
    // this.fetch();
  },
  methods: {
    fetch() {
      return this.$refs.baseTable.fetchData();
    },
    onClick(selected) {
      if (this.selected === selected) {
        this.$emit("update:selected", null);
      } else {
        this.$emit("update:selected", selected);
      }
    },
    onCheck(checked) {
      this.$emit("update:checked", checked);
    }
  }
};
</script>

<style scoped>
.card-content {
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Codes/list/partials/table.vue